import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-magic-numbers */
// magic numbers are used to make the layout
import { CoreContainer } from '@hub/core-container';
import { H3 } from '@hub/heading';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import React from 'react';
import { Cluster } from '@hub/cluster';
import { IncludeDirectLogo } from '@hub/icon/src/with-direct-logo';
import { Grid } from '@hub/grid';
import { LinkOverlay } from '@hub/link';
import { AnalyticsImpressionTracker } from '@scentregroup/shared/analytics-observer';
import trackClickEvents, { categories } from '../analytics/trackEvents';
import { AsMeasured } from '../as-measured';
import { CloudinaryImage } from '../cloudinary-image';
import { TrackLinkBox } from '../../analytics-observer/track-link-box';
import { CategoryTile } from './category-tile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function makeFeatureItemsSx(numOfFeatureItems) {
  const baseSX = {
    flexGrow: [1, 'initial'],
    flexShrink: 1
  };
  const sideSX = {
    minWidth: ['size-13', 'size-10', 'size-15'],
    flexBasis: ['size-13', 'size-10', 'size-15'],
    flexGrow: 1,
    flexShrink: 1
  };
  const centerSX = {
    minWidth: ['size-19', 'calc(42.5% - 16px)'],
    flexBasis: ['size-full', 'size-16', 'calc(42.5% - 16px)']
  };

  switch (numOfFeatureItems) {
    case 1:
      return {
        item1: _objectSpread({
          order: [null, 2],
          minWidth: ['size-19', '50%'],
          flexBasis: ['size-full', 'size-16', '50%']
        }, baseSX)
      };

    case 2:
      return {
        item1: _objectSpread({}, centerSX),
        item2: _objectSpread({}, centerSX)
      };

    case 3:
    default:
      return {
        item1: _objectSpread({
          order: [null, 2],
          minWidth: ['size-19', '36%'],
          flexBasis: ['size-full', 'size-16', '36%']
        }, baseSX),
        item2: _objectSpread({
          order: [null, 1]
        }, sideSX),
        item3: _objectSpread({
          order: [null, 3]
        }, sideSX)
      };
  }
}

export const CategorySpotlight = _ref => {
  let {
    title,
    text,
    analyticsSlot,
    items: _items,
    as,
    clickEvent,
    viewEvent,
    enableH1Heading
  } = _ref;
  const items = [..._items]; // take a copy to avoid mutating input value

  const item1 = items.shift();
  const item2 = items.shift();
  const item3 = items.shift();
  const numOfFeatureItems = [item1, item2, item3].filter(Boolean).length;
  const featureItemsSX = makeFeatureItemsSx(numOfFeatureItems);
  const handler = React.useCallback(item => {
    if (viewEvent === undefined) {
      return undefined;
    }

    return () => viewEvent(item);
  }, [viewEvent]);
  return /*#__PURE__*/_jsx(CoreContainer, {
    as: as,
    "data-id": "category-spotlight_index_CategorySpotlight_CoreContainer",
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: "spacing-sm",
      "data-id": "category-spotlight_index_CategorySpotlight_CoreContainer_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        gap: "spacing-none",
        "data-id": "category-spotlight_index_CategorySpotlight_Stack_Stack_2",
        children: [/*#__PURE__*/_jsx(H3, {
          align: "center",
          as: enableH1Heading ? 'h1' : 'h3',
          "data-id": "category-spotlight_index_CategorySpotlight_Stack_H3",
          children: title && /*#__PURE__*/_jsx(IncludeDirectLogo, {
            title: title,
            "data-id": "category-spotlight_index_CategorySpotlight_IncludeDirectLogo"
          })
        }), /*#__PURE__*/_jsx(Text, {
          isBodyText: true,
          align: "center",
          color: "quartz",
          "data-id": "category-spotlight_index_CategorySpotlight_Stack_Text",
          children: text
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        gap: ['spacing-sm', 'spacing-md'],
        "data-id": "category-spotlight_index_CategorySpotlight_Stack_Stack",
        children: [/*#__PURE__*/_jsxs(Cluster, {
          wrap: "wrap",
          gap: ['spacing-sm', 'spacing-md'],
          align: "center",
          justify: "center",
          "data-id": "category-spotlight_index_CategorySpotlight_Stack_Cluster",
          children: [item1 && /*#__PURE__*/_jsx(AnalyticsImpressionTracker, _objectSpread(_objectSpread({
            child: CategoryTile,
            sx: featureItemsSX.item1,
            as: props => {
              var _item1$orchestrationM, _item1$orchestrationM2;

              return /*#__PURE__*/_jsx(AsMeasured, _objectSpread(_objectSpread({}, props), {}, {
                metadata: item1.analyticsMetadata,
                slot: (_item1$orchestrationM = (_item1$orchestrationM2 = item1.orchestrationMetadata) === null || _item1$orchestrationM2 === void 0 ? void 0 : _item1$orchestrationM2.displayId) !== null && _item1$orchestrationM !== void 0 ? _item1$orchestrationM : analyticsSlot,
                onClick: () => clickEvent(0),
                "data-id": "category-spotlight_index_CategorySpotlight_AsMeasured"
              }));
            },
            onCreateImpressionWhenView: handler(item1)
          }, item1), {}, {
            "data-id": "category-spotlight_index_CategorySpotlight_AnalyticsImpressionTracker"
          })), item2 && /*#__PURE__*/_jsx(AnalyticsImpressionTracker, _objectSpread(_objectSpread({
            child: CategoryTile,
            sx: featureItemsSX.item2,
            as: props => {
              var _item2$orchestrationM, _item2$orchestrationM2;

              return /*#__PURE__*/_jsx(AsMeasured, _objectSpread(_objectSpread({}, props), {}, {
                metadata: item2.analyticsMetadata,
                slot: (_item2$orchestrationM = (_item2$orchestrationM2 = item2.orchestrationMetadata) === null || _item2$orchestrationM2 === void 0 ? void 0 : _item2$orchestrationM2.displayId) !== null && _item2$orchestrationM !== void 0 ? _item2$orchestrationM : analyticsSlot,
                onClick: () => clickEvent(1),
                "data-id": "category-spotlight_index_CategorySpotlight_AsMeasured"
              }));
            },
            onCreateImpressionWhenView: handler(item2)
          }, item2), {}, {
            "data-id": "category-spotlight_index_CategorySpotlight_AnalyticsImpressionTracker"
          })), item3 && /*#__PURE__*/_jsx(AnalyticsImpressionTracker, _objectSpread(_objectSpread({
            child: CategoryTile,
            sx: featureItemsSX.item3,
            as: props => {
              var _item3$orchestrationM, _item3$orchestrationM2;

              return /*#__PURE__*/_jsx(AsMeasured, _objectSpread(_objectSpread({}, props), {}, {
                metadata: item3.analyticsMetadata,
                slot: (_item3$orchestrationM = (_item3$orchestrationM2 = item3.orchestrationMetadata) === null || _item3$orchestrationM2 === void 0 ? void 0 : _item3$orchestrationM2.displayId) !== null && _item3$orchestrationM !== void 0 ? _item3$orchestrationM : analyticsSlot,
                onClick: () => clickEvent(2),
                "data-id": "category-spotlight_index_CategorySpotlight_AsMeasured"
              }));
            },
            onCreateImpressionWhenView: handler(item3)
          }, item3), {}, {
            "data-id": "category-spotlight_index_CategorySpotlight_AnalyticsImpressionTracker"
          }))]
        }), /*#__PURE__*/_jsx(Grid, {
          gap: ['spacing-sm', 'spacing-md'],
          templateColumns: ['repeat(2, 1fr)', 'repeat(3, 1fr)', null, 'repeat(6 ,1fr)'],
          maxWidth: ['size-lg', 'size-lg', 'size-lg', 'size-md'],
          "data-id": "category-spotlight_index_CategorySpotlight_Stack_Grid",
          children: items.map((item, index) => /*#__PURE__*/_jsx(TrackLinkBox, {
            onClick: () => {
              clickEvent(index + 3);
              trackClickEvents.clicked(categories.CATEGORY_DECK, "Sub Category | ".concat(item.title));
            },
            onCreateImpressionWhenView: handler(item),
            "data-id": "category-spotlight_index_CategorySpotlight_TrackLinkBox",
            children: /*#__PURE__*/_jsxs(Stack, {
              direction: ['row', 'row', 'row', 'column'],
              shouldWrapChildren: false,
              gap: ['spacing-sm', 'spacing-sm', 'spacing-sm', 'spacing-none'],
              sx: {
                alignContent: 'center',
                justifyContent: 'center',
                backgroundColor: 'smoke',
                height: 'size-full',
                padding: ['spacing-sm', 'spacing-sm', 'spacing-sm', null]
              },
              flexGrow: 0,
              as: props => {
                var _item$orchestrationMe, _item$orchestrationMe2;

                return /*#__PURE__*/_jsx(AsMeasured, _objectSpread(_objectSpread({}, props), {}, {
                  metadata: item.analyticsMetadata,
                  slot: (_item$orchestrationMe = (_item$orchestrationMe2 = item.orchestrationMetadata) === null || _item$orchestrationMe2 === void 0 ? void 0 : _item$orchestrationMe2.displayId) !== null && _item$orchestrationMe !== void 0 ? _item$orchestrationMe : analyticsSlot,
                  "data-id": "category-spotlight_index_CategorySpotlight_AsMeasured"
                }));
              },
              "data-id": "category-spotlight_index_CategorySpotlight_TrackLinkBox_Stack",
              children: [/*#__PURE__*/_jsx(CloudinaryImage, {
                ratio: "1",
                imageSetOrImage: item.image,
                minWidth: "size-xs",
                sizes: {
                  sm: 48,
                  md: 64,
                  lg: 100
                },
                sx: {
                  marginX: [null, null, null, 'spacing-lg'],
                  marginTop: [null, null, null, 'spacing-xs'],
                  marginBottom: [null, null, null, 'spacing-sm'],
                  flexShrink: [0, 0, 0, 1],
                  flexGrow: [0, 0, 0, 1],
                  flexBasis: ['size-8', 'size-8', 'size-sm', 'auto']
                },
                "data-id": "category-spotlight_index_CategorySpotlight_Stack_CloudinaryImage"
              }), /*#__PURE__*/_jsx(Text, {
                as: "span",
                fontSize: ['font-md', 'font-xl'],
                tone: "strong",
                align: ['left', 'left', 'left', 'center'],
                sx: {
                  flexGrow: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: ['flex-start', 'flex-start', 'flex-start', 'center']
                },
                "data-id": "category-spotlight_index_CategorySpotlight_Stack_Text",
                children: /*#__PURE__*/_jsx(LinkOverlay, {
                  href: item.callToAction.url,
                  "data-id": "category-spotlight_index_CategorySpotlight_Text_LinkOverlay",
                  children: item.title
                })
              })]
            })
          }, item.title))
        })]
      })]
    })
  });
};